import script from "./SidebarApp.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarApp.vue?vue&type=script&setup=true&lang=js"

import "./SidebarApp.vue?vue&type=style&index=0&id=5504df5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5504df5c"]])

export default __exports__